export const isTokensSelected = (editor): boolean => {
  const selectionWrapper: HTMLDivElement = editor.dom.create('div', null, editor.selection.getContent());
  const tokens = selectionWrapper.querySelectorAll('span.cbNonEditable');
  return Array.from(tokens).some(token => selectionWrapper.contains(token));
};
